const route = {
	path: ':codeProject/actions',
	name: 'page-action',
	meta: {
		title: 'Barra de Acciones',
	},
	props: true,
	component: () => import('@/pages/actions/page-action'),
	children: [
		{
			path: 'new',
			name: 'page-action-new',
			meta: {
				title: 'Nueva Acción',
			},
			component: () => import('@/pages/actions/page-action-new'),
			props: true,
		},
		{
			path: ':id/edit',
			name: 'page-action-edit',
			meta: {
				title: 'Editar Acción',
			},
			component: () => import('@/pages/actions/page-action-new'),
			props: true,
		},
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/actions.js